import { Navigate, useParams } from "react-router";
import { PublicRoutes } from "@/constants/routes";

/**
 * A vitrine saiu do backoffice: a oficial é a pública, em /design-system.
 * O endereço antigo continua valendo para não quebrar link salvo em doc,
 * PR ou favorito — leva para a mesma página do lado público.
 *
 * Não usa o `designSystemPath` do registry de propósito: o registry importa
 * toda a documentação, e este arquivo entra no bundle do router.
 */
export const BackofficeDesignSystemRedirect = () => {
  const { slug } = useParams<{ slug?: string }>();
  return (
    <Navigate
      to={
        slug
          ? `${PublicRoutes.DESIGN_SYSTEM}/${slug}`
          : PublicRoutes.DESIGN_SYSTEM
      }
      replace
    />
  );
};
